module.exports = __webpack_public_path__ + "img/CheckBox.f3df6d1a.svg";